const checkResult = result => {
  if (result === null || result === undefined) {
    return '-';
  }
  return result;
};

export default checkResult;
